import { FixedHeader } from "./components/fixed-header";

document.addEventListener("DOMContentLoaded", () => {
    const fixedHeader = new FixedHeader();
    fixedHeader.init();
});
